export const DIALPAD_SUPER_ADMIN_LOGIN_URL = '/login/superadmin/';
export const DIALPAD_LOGIN_REDIRECT_URL = '/login/dialpad/complete/';
export const DIALPAD_LOGIN_START_URL = '/login/dialpad/start/';
